import { combineReducers } from "@reduxjs/toolkit";

import archiveReportsByOrders from "./byOrders";

const archiveReportCharts = combineReducers({
	byOrders: archiveReportsByOrders.reducer,
});

export default archiveReportCharts;
